import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mb-3" }
const _hoisted_2 = { class: "ms-3 mb-0" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mb-3 pre"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-2 bg-white" }
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = {
  key: 0,
  class: "text-success"
}
const _hoisted_9 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_10 = {
  key: 2,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggler = _resolveComponent("toggler")!
  const _component_accordion = _resolveComponent("accordion")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadTables && _ctx.loadTables(...args)))
      }, "Carica tabelle dal DB"),
      _createElementVNode("button", {
        class: "btn btn-sm btn-success ms-2",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveAndApply && _ctx.saveAndApply(...args)))
      }, "Salva e applica indici"),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control form-control-sm ms-3 w-auto",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter) = $event)),
        placeholder: "Filtra tabelle"
      }, null, 512), [
        [_vModelText, _ctx.filter]
      ]),
      _createElementVNode("label", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.onlyIndexed) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.onlyIndexed]
        ]),
        _cache[4] || (_cache[4] = _createTextVNode(" Solo tabelle con indici "))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missingItems, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "text-danger mb-3",
        key: 'm' + i
      }, [
        _createElementVNode("button", {
          class: "btn btn-danger btn-sm",
          onClick: ($event: any) => (_ctx.removeMissing(item.table, item.column))
        }, "-", 8, _hoisted_3),
        (item.column)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[5] || (_cache[5] = _createTextVNode(" Colonna ")),
              _createElementVNode("b", null, _toDisplayString(item.column), 1),
              _cache[6] || (_cache[6] = _createTextVNode(" non presente nella tabella ")),
              _createElementVNode("b", null, _toDisplayString(item.table), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[7] || (_cache[7] = _createTextVNode(" Tabella ")),
              _createElementVNode("b", null, _toDisplayString(item.table), 1),
              _cache[8] || (_cache[8] = _createTextVNode(" non presente nel DB "))
            ], 64))
      ]))
    }), 128)),
    (_ctx.applyResult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("b", null, "Esito applicazione indici:", -1)),
          (_ctx.applyResult.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Nessun errore"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applyResult, (line, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(line), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTables, (table) => {
      return (_openBlock(), _createBlock(_component_accordion, {
        key: table.name,
        class: "mb-2"
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(table.name), 1),
              (_ctx.getFlagged(table.name).length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" (" + _toDisplayString(_ctx.getFlagged(table.name).length) + " indici) ", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                _createElementVNode("th", null, "Indicizza"),
                _createElementVNode("th", null, "Colonna"),
                _createElementVNode("th", null, "Tipo"),
                _createElementVNode("th", null, "Descrizione"),
                _createElementVNode("th", null, "Indici presenti"),
                _createElementVNode("th", null, "Stato")
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.columns, (column) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: column.name
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_toggler, {
                        modelValue: _ctx.isFlagged(table.name, column.name),
                        "onUpdate:modelValue": ($event: any) => (_ctx.setFlag(table.name, column.name, $event))
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(column.name), 1),
                    _createElementVNode("td", null, _toDisplayString(column.dataType), 1),
                    _createElementVNode("td", null, _toDisplayString(column.comment), 1),
                    _createElementVNode("td", null, _toDisplayString(column.indexes.join(", ")), 1),
                    _createElementVNode("td", null, [
                      (_ctx.isFlagged(table.name, column.name) && _ctx.isApplied(column))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "attivo"))
                        : (_ctx.isFlagged(table.name, column.name))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "da applicare"))
                          : (_ctx.isApplied(column))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "da rimuovere"))
                            : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}